import styled from "styled-components";

export const Section = styled.section`
	padding: 4rem 0;
	background-color: #fff;

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1rem;
	}

	.text-center {
		text-align: center;
		margin-bottom: 3rem;
	}
`;

export const SectionTitle = styled.h2`
	font-size: 2rem;
	font-weight: 700;
	color: #1a1a2e;
	margin-bottom: 0.5rem;

	@media (min-width: 768px) {
		font-size: 2.5rem;
	}
`;

export const SectionSubtitle = styled.p`
	color: #6b7280;
	max-width: 600px;
	margin: 0.75rem auto 0;
	font-size: 1rem;
	line-height: 1.6;
`;

export const StepsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 2rem;

	@media (min-width: 576px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (min-width: 992px) {
		grid-template-columns: repeat(4, 1fr);
	}
`;

export const StepCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	transition: transform 0.2s;

	&:hover {
		transform: translateY(-4px);
	}

	h3 {
		font-size: 1.1rem;
		font-weight: 600;
		margin-bottom: 0.5rem;
		color: #1a1a2e;
	}

	p {
		font-size: 0.9rem;
		color: #6b7280;
		line-height: 1.5;
	}
`;

export const StepIconWrapper = styled.div`
	position: relative;
	width: 4rem;
	height: 4rem;
	border-radius: 50%;
	background-color: rgba(100, 43, 115, 0.1);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1rem;
	color: #642b73;
	transition: background-color 0.2s;

	${StepCard}:hover & {
		background-color: rgba(100, 43, 115, 0.2);
	}
`;

export const StepNumber = styled.span`
	position: absolute;
	top: -0.5rem;
	right: -0.5rem;
	width: 1.75rem;
	height: 1.75rem;
	border-radius: 50%;
	background-color: #642b73;
	color: #fff;
	font-size: 0.8rem;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
`;
